import type { MarketCode } from '@hc/shared';

// Map framing per market — centroid + a zoom that fits the country in a
// typical dockview panel. Shared by every Leaflet surface that opens scoped
// to a market (Facilities Map, Prevalence map). One table so a new market is
// added once, not per-panel.

export interface MapView {
  center: [number, number];
  zoom: number;
}

/** Continent frame — the default when no market scope is expressed. */
export const EUROPE_VIEW: MapView = { center: [52, 10], zoom: 4 };

export const MARKET_VIEW: Record<MarketCode, MapView> = {
  AT: { center: [47.6, 14.1], zoom: 7 },
  BE: { center: [50.6, 4.5], zoom: 8 },
  BG: { center: [42.7, 25.2], zoom: 7 },
  CH: { center: [46.8, 8.2], zoom: 8 },
  CZ: { center: [49.8, 15.5], zoom: 7 },
  DE: { center: [51.2, 10.4], zoom: 6 },
  DK: { center: [56.0, 10.0], zoom: 7 },
  EE: { center: [58.7, 25.0], zoom: 7 },
  ES: { center: [40.3, -3.7], zoom: 6 },
  FI: { center: [64.5, 26.0], zoom: 5 },
  FR: { center: [46.6, 2.4], zoom: 6 },
  GB: { center: [54.4, -3.2], zoom: 6 },
  GR: { center: [39.0, 22.5], zoom: 6 },
  HR: { center: [45.0, 16.0], zoom: 7 },
  HU: { center: [47.2, 19.4], zoom: 7 },
  IE: { center: [53.4, -8.0], zoom: 7 },
  IT: { center: [42.5, 12.5], zoom: 6 },
  LT: { center: [55.2, 23.9], zoom: 7 },
  LV: { center: [56.9, 24.9], zoom: 7 },
  NL: { center: [52.2, 5.4], zoom: 7 },
  NO: { center: [64.5, 12.0], zoom: 5 },
  PL: { center: [52.1, 19.3], zoom: 6 },
  PT: { center: [39.6, -8.0], zoom: 7 },
  RO: { center: [45.9, 25.0], zoom: 7 },
  SE: { center: [62.5, 16.5], zoom: 5 },
  SI: { center: [46.1, 14.8], zoom: 8 },
  SK: { center: [48.7, 19.5], zoom: 7 },
};

/** Frame for a set of markets: one market → its country view; several or
 *  none → the Europe frame. */
export function viewForMarkets(codes: readonly MarketCode[]): MapView {
  if (codes.length === 1) return MARKET_VIEW[codes[0]!] ?? EUROPE_VIEW;
  return EUROPE_VIEW;
}
